<template>
  <div>
    <div class="main-title">财务流水账
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm" size="small">
          <el-form-item>
            <el-dropdown @command="handleCommand">
              <el-button type="primary">
                新增收支<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="inc">新增收入</el-dropdown-item>
                <el-dropdown-item command="exp">新增支出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item v-if="user.group_id == 22">
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择考场"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.fin_type"
              @change="search(searchParams)"
              style="width:120px">
              <el-option label="全部类型" :value="null"></el-option>
              <el-option label="收入" value="1"></el-option>
              <el-option label="支出" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="收支日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="编号/收(付)款人/凭证号/备注"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              style="width:220px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.fin_item"
              filterable
              placeholder="收支项目"
              style="width:120px"
              @change="search(searchParams)">
              <el-option label="全部收支项目" value=""></el-option>
              <el-option 
                v-for="item in finItemList" 
                :key="item.id"  
                :value="item.item_name"
                :label="item.item_name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.pay_type"
              filterable
              placeholder="支付方式"
              style="width:120px"
              @change="search(searchParams)">
              <el-option label="全部支付方式" value=""></el-option>
              <el-option label="现金" value="现金"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="微信支付" value="微信支付"></el-option>
              <el-option label="刷卡" value="刷卡"></el-option>
              <el-option label="转账" value="转账"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.fin_account"
              filterable
              placeholder="收支账户"
              style="width:120px"
              @change="search(searchParams)">
              <el-option label="全部收支账户" :value="null"></el-option>
              <el-option 
                v-for="item in accountList" 
                :key="item.id"  
                :value="item.id"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.oper_id"
              filterable
              placeholder="操作员"
              style="width:120px"
              @change="search(searchParams)"
              :disabled="user.buttons.indexOf(1019) < 0">
              <el-option label="全部操作员" :value="null"></el-option>
              <el-option 
                v-for="item in userList" 
                :key="item.id"  
                :value="item.id"
                :label="item.realname">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="金额"
              v-model="searchForm.fin_money"
              clearable
              prefix-icon="el-icon-search"
              style="width:80px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="searchForm.show_invalid" @change="search(searchParams)" true-label="1" false-label="0">包括已作废</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <el-button style="margin-bottom:10px" v-if="selectRows.length > 0" @click="multiPrint">打印单据</el-button>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        style="width:100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="所属考场"
          width="100"
          v-if="user.group_id == 22">
        </el-table-column>
        <el-table-column
          prop="fin_type_name"
          label="类型"
          width="70"
          :filters="[{ text: '收入', value: '收入'}, {text: '支出', value: '支出'}]"
          :filter-method="filterFinType">
        </el-table-column>
        <el-table-column
          prop="fin_item"
          label="收支项目"
          width="180">
        </el-table-column>
        <el-table-column
          prop="fin_money"
          label="金额"
          width="100">
        </el-table-column>
        <el-table-column
          label="打印"
          width="70">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.fin_status === '正常'" @click="print(scope.row)">打印</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_person"
          label="收(付)款人"
          width="150">
        </el-table-column>
        <el-table-column
          prop="pay_type"
          label="支付方式"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fin_account_name"
          label="收支账户"
          width="130">
        </el-table-column>
        <el-table-column
          prop="fin_status"
          label="状态"
          width="70">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="fin_time"
          label="操作时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="fin_no"
          label="凭证号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="files"
          label="附件"
          width="100">
          <template slot-scope="scope">
            <div v-if="!scope.row.files"></div>
            <div v-else>
              <a v-for="file in JSON.parse(scope.row.files)" :key="file" :href="file" target="_blank"><img :src="file" style="width:24px;height:24px;margin-left:2px;"></a>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="600"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.fin_status === '正常'" @click="edit(scope.row)" :disabled="user.buttons.indexOf(1022) < 0 && user.buttons.indexOf(1025) < 0">修改</el-button>
            <el-button type="text" v-if="scope.row.fin_status === '正常'" @click="invalid(scope.row)" style="color:#f56c6c;" :disabled="user.buttons.indexOf(1022) < 0 && user.buttons.indexOf(1025) < 0">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增收支 -->
    <el-dialog :title="addFormTitle" :visible.sync="addFormVisible">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="120px">
        <el-form-item label="所属考场" v-if="user.group_id == 22">
          <el-select v-model="addForm.company_id">
            <el-option label="全部考场" :value="0"></el-option>
            <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="addForm.fin_type === '1' ? '收入项目' : '支出项目'" prop="fin_item">
          <el-col :span="11">
            <el-select v-model="addForm.fin_item" placeholder="请选择项目" filterable style="width:100%">
              <el-option v-for="i in finItemListFilter" :key="i.id" :label="i.item_name" :value="i.item_name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="addForm.fin_no" placeholder="凭证号(可以不填)" style="width:100%"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="addForm.fin_type === '1' ? '收入金额' : '支出金额'" prop="fin_money">
          <el-col :span="11">
            <el-input v-model="addForm.fin_money"></el-input>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="addForm.fin_person" :placeholder="addForm.fin_type === '1' ? '付款人' : '收款人'">
              <el-button slot="append" @click="readIdcard" :loading="idcardReading">读身份证</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="支付方式" prop="pay_type">
          <el-col :span="11">
            <el-select v-model="addForm.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="微信支付" value="微信支付"></el-option>
              <el-option label="刷卡" value="刷卡"></el-option>
              <el-option label="转账" value="转账"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-form-item prop="fin_account">
              <el-select v-model="addForm.fin_account" placeholder="请选择账户" style="width:100%">
                <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="收支日期" v-if="addForm.id > 0">
          <el-date-picker v-model="addForm.fin_time" :disabled="user.buttons.indexOf(1022) < 0" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" autosize placeholder="备注(可以不填)"></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            ref="finFileUpload"
            drag
            :action="uploadActionURL"
            :headers="uploadHeaders"
            :on-success="handleScucess"
            :on-remove="handleRemove"
            :file-list="fileList"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
        <el-button @click="addFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  props: {
    user: Object
  },
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'fin_list',
      pageSize: 100,
      searchForm: {
        company_ids: [],
        query: '',
        fin_item: '',
        daterange: [
          //new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          //new Date()
        ],
        pay_type: '',
        oper_id: null,
        show_invalid: '1',
        fin_money: '',
        fin_account: null,
        fin_type: null
      },
      addForm: {
        id: 0,
        fin_type: '1',
        fin_item: '',
        pay_type: '现金',
        fin_account: '',
        fin_money: 0,
        fin_person: '',
        fin_no: '',
        fin_time_ori: '',
        fin_time: '',
        remark: '',
        company_id: 0,
      },
      files: [],
      fileList: [],
      addFormRules: {
        fin_item: [
          { required: true, message: '请选择项目', trigger: 'blur' }
        ],
        fin_account: [
          { required: true, message: '请选择账户', trigger: 'blur' }
        ],
        fin_money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false,
      finItemList: [],
      accountList: [],
      userList: [],
      companyList: [],
      studentDetailVisible: false,
      studentDetailStuId: 0,
      today: moment().format('YYYY-MM-DD'),
      idcardReading: false,
      uploadActionURL: process.env.NODE_ENV === 'production' ? 'https://kcapi.codetrust.cn/api/upload' : 'http://localhost:20184/api/upload',
      uploadHeaders: {
        token: localStorage.getItem('kaochang.token'),
        'Access-Control-Allow-Origin': '*'
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      let params = { ...this.searchForm }
      if (this.searchForm.daterange && this.searchForm.daterange.length > 0) {
        params = {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          fin_item: this.searchForm.fin_item,
          show_invalid: this.searchForm.show_invalid,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59',
          pay_type: this.searchForm.pay_type,
          oper_id: this.searchForm.oper_id,
          fin_money: this.searchForm.fin_money,
          fin_account: this.searchForm.fin_account,
          fin_type: this.searchForm.fin_type
        }
      }
      if (this.user.buttons.indexOf(1019) < 0) {
        params.oper_id = this.user.id
      }
      return params
    },
    finItemListFilter () {
      if (this.addForm.fin_type === '1') {
        return this.finItemList.filter(i => i.item_type === '1')
      }
        return this.finItemList.filter(i => i.item_type === '0')
    },
    accountListFilter () {
      if (this.addForm.pay_type === '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (this.addForm.pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (this.addForm.pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (this.addForm.pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行' || i.account_type === '其他')
      } else if (this.addForm.pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行' || i.account_type === '其他')
      } else if (this.addForm.pay_type === '其他') {
        return this.accountList.filter(i => i.account_type === '其他')
      } else {
        return []
      }
    },
    addFormTitle () {
      if (this.addForm.id > 0) {
        if (this.addForm.fin_type === '1') {
          return '修改收入'
        } else {
          return '修改支出'
        }
      } else {
        if (this.addForm.fin_type === '1') {
          return '新增收入'
        } else {
          return '新增支出'
        }
      }
    }
  },
  mounted () {
    this.fetchFinItemList()
    this.fetchAccountList()
    this.fetchUserList()
    this.fetchCompanyList()
  },
  methods: {
    handleScucess (res, file) {
      if (res.success) {
        file.url = res.url
        this.files.push(res.url)
      }
    },
    handleRemove (file, fileList) {
      this.files.splice(this.files.indexOf(file.url), 1)
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.fin_status === '已作废') {
        return 'row-red'
      } else {
        return ''
      }
    },
    filterFinType (value, row) {
      return row.fin_type_name === value
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'fin_money') {
          let i = -1
          sums[index] = values.reduce((prev, curr) => {
            i++
            const value = Number(curr)
            if (!isNaN(value) && data[i].fin_status === '正常') {
              if (data[i].fin_type === '0') {
                return prev - curr
              } else {
                return prev + curr
              }
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else if (column.property === 'fin_item') {
          sums[index] = '本页结余'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    fetchFinItemList () {
      this.$http.get('/dbapi/fin_item_combo').then(response => {
        if (response.data.success) {
          this.finItemList = response.data.list
        }
      })
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          if (this.accountList.length > 0) {
            this.addForm.fin_account = this.accountList[0].id
          }
        }
      })
    },
    fetchUserList () {
      this.$http.get('/dbapi/user_list').then(response => {
        if (response.data.success) {
          this.userList = response.data.list
        }
      })
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    handleCommand (command) {
      if (command === 'inc') {
        this.addForm = {
          fin_type: '1',
          fin_item: '',
          pay_type: '现金',
          fin_account: this.accountList.length > 0 ? this.accountList[0].id : null,
          fin_money: 0,
          fin_person: '',
          fin_no: '',
          remark: '',
          company_id: 0
        }
        this.addFormVisible = true
      } else if (command === 'exp') {
        this.addForm = {
          fin_type: '0',
          fin_item: '',
          pay_type: '现金',
          fin_account: this.accountList.length > 0 ? this.accountList[0].id : null,
          fin_money: 0,
          fin_person: '',
          fin_no: '',
          remark: '',
          company_id: 0
        }
        this.addFormVisible = true
      }
      this.files = []
      this.$refs.finFileUpload && this.$refs.finFileUpload.clearFiles()
    },
    edit (row) {
      if (row.fin_time.indexOf(this.today) < 0 && this.user.buttons.indexOf(1022) < 0) {
        this.$alert('只允许修改今天的数据', '提示')
        return
      }
      this.addForm = {
        id: row.id,
        fin_type: row.fin_type,
        fin_item: row.fin_item,
        pay_type: row.pay_type,
        fin_account: row.fin_account,
        fin_money: row.fin_money,
        fin_person: row.fin_person,
        fin_no: row.fin_no,
        fin_time_ori: row.fin_time,
        fin_time: row.fin_time.substr(0,10),
        remark: row.remark,
        company_id: row.company_id
      }
      this.files = !row.files ? [] : JSON.parse(row.files)
      this.fileList = !row.files ? [] : JSON.parse(row.files).map(f => ({name:f,url:f}))
      this.addFormVisible = true
    },
    addFormCommit () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addFormCommiting = true
          let url = '/dbapi/fin_insert'
          if (this.addForm.id > 0) {
            url = '/dbapi/fin_update'
            this.addForm.fin_time = this.addForm.fin_time + this.addForm.fin_time_ori.substr(10)
          }
          this.addForm.files = JSON.stringify(this.files)
          this.$http.post(url, this.addForm).then(response => {
            this.addFormCommiting = false
            if (response.data.success) {
              this.$refs.addForm.resetFields()
              this.addFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '保存成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    stuDetail (row) {
      this.studentDetailStuId = row.id
      this.studentDetailVisible = true
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.addForm.fin_account = this.accountListFilter[0].id
      }
    },
    invalid (row) {
      if (row.fin_time.indexOf(this.today) < 0 && this.user.buttons.indexOf(1022) < 0) {
        this.$alert('只允许作废今天的记录', '提示')
        return
      }
      this.$prompt(`请输入作废备注`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post('/dbapi/fin_invalid', {
          id: row.id,
          remark: value
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    print (row) {
      if (row.fin_type === '0') {
        let url = '/expend_print'
        if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
          url = '/expend_print_1'
        }
        if ([2, 8].indexOf(this.user.group_id) >= 0) {
          url = '/expend_print_blank'
        }
        window.open(this.$http.receiptBaseUrl + url + '?token=' + localStorage.getItem('kaochang.token') + '&id=' + row.id)
      } else {
        let ids = '&ids=' + row.id
        window.open(this.$http.receiptBaseUrl + '/fin_print?token=' + localStorage.getItem('kaochang.token') + ids)
      }
    },
    multiPrint () {
      let ids = ''
      for (var i = 0; i < this.selectRows.length; i++) {
        ids += '&ids=' + this.selectRows[i].id
      }
      if (this.selectRows[0].fin_type === '0') {
        let url = '/expend_print'
        if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
          url = '/expend_print_1'
        }
        if ([2, 8].indexOf(this.user.group_id) >= 0) {
          url = '/expend_print_blank'
        }
        window.open(this.$http.receiptBaseUrl + url + '?token=' + localStorage.getItem('kaochang.token') + ids)
      } else {
        window.open(this.$http.receiptBaseUrl + '/fin_print?token=' + localStorage.getItem('kaochang.token') + ids)
      }
    },
    readIdcard () { // 读身份证
      this.idcardReading = true
      this.$idcard.read().then(data => {
        this.idcardReading = false
        this.addForm.fin_person = data.name
        this.addForm.remark = data.code
      }).catch(() => {
        this.idcardReading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/finance/Index.vue